import { createSlice } from '@reduxjs/toolkit'

interface ModalState {
  openPricingModal: boolean
  openOfferModal: boolean
}

const initialState: ModalState = {
  openPricingModal: false,
  openOfferModal: false,
}

export const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    setOpenPricingModal: (state, action) => {
      state.openPricingModal = action.payload
    },
    setOpenOfferModal: (state, action) => {
      state.openOfferModal = action.payload
    },
    resetModals: (state) => {
      state.openPricingModal = false
      state.openOfferModal = false
    },
  },
})

export const { setOpenPricingModal, setOpenOfferModal, resetModals } = modalSlice.actions

export default modalSlice.reducer
